const GB_VALUE_QUALIFIERS = ['eshop_size', 'ram_capacity'];

type VariantOptionValue = {
    qualifier?: string;
    value?: string;
};

export const formatVariantOptionValue = ({ qualifier, value }: VariantOptionValue) => {
    return GB_VALUE_QUALIFIERS.includes((qualifier || '').toLowerCase()) ? `${value} GB` : value;
};
